// Ayudas de la página «Reporte semanal» (migración 20261016a_owner_weekly_report.sql). El texto del mensaje está en ownerReport.js.

const BOGOTA_DAY = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit' });

// La semana completa más reciente (lunes a domingo, hora de Colombia): { from: lunes, to: lunes siguiente (exclusivo) } como «AAAA-MM-DD».
export const lastWeekRange = (now = new Date()) => {
  const [y, m, d] = BOGOTA_DAY.format(now).split('-').map(Number);
  const today = new Date(Date.UTC(y, m - 1, d));
  const sinceMonday = (today.getUTCDay() + 6) % 7;
  const to = new Date(today.getTime() - sinceMonday * 86400000);
  const from = new Date(to.getTime() - 7 * 86400000);
  const iso = (dt) => dt.toISOString().slice(0, 10);
  return { from: iso(from), to: iso(to) };
};

const STATUS = {
  enviado: { label: 'Enviado', tone: 'text-emerald-400' },
  pendiente: { label: 'En cola', tone: 'text-amber-300' },
  enviando: { label: 'Enviando…', tone: 'text-amber-300' },
  error: { label: 'No se pudo enviar', tone: 'text-rose-300' },
  omitido: { label: 'Sin actividad: no se envió', tone: 'text-seryi-text' }
};
export const reportStatusInfo = (r) => STATUS[r?.status] || STATUS.omitido;
